import './gallery.scss';
import Dropdown from 'classes/Dropdown';
import Hooks from 'classes/Hooks';
import { get_offset } from 'js/utils';

const hooks = new Hooks([]);

init();
function init(){
    document.querySelectorAll('.custom_gallery').forEach(gallery_customization)
    init_gallery_select();
}

function gallery_customization(el){
    const items = el.querySelectorAll('.elementor-gallery-item')
    img_1_customization(items);
    img_2_customization(items);
}

function img_1_customization(items){
    const item = items[0];
    if( !item ) return;
    item.classList.add('gallery_item_1');
    // item.querySelector('.e-gallery-image').style.backgroundImage = `url(${item.href})`;
    item.querySelector('.e-gallery-image').dataset.thumbnail = item.href;
}

function img_2_customization(items){
    const item = items[1];
    if( !item ) return;
    item.classList.add('gallery_item_2');
    item.querySelector('.e-gallery-image').dataset.thumbnail = item.href;
}

function init_gallery_select(){

    const select = document.querySelector('.gallery_select select')
    if( !select ) return;

    const init_option = (el)=>{

        const option = document.createElement('option')

        const gallery_name = el.textContent;
        option.textContent = gallery_name;
        option.value = gallery_name;
        
        const scroll_to_gallery = ()=>{
            window.scrollTo({
                top: get_offset(el).top - 80,
                behavior: 'smooth',
            })
        }

        hooks.add(`gallery/select/${gallery_name}`, scroll_to_gallery)
        select.append(option)
    }
    
    document.querySelectorAll('.gallery_heading .elementor-heading-title').forEach(init_option)
    
    const ui = new Dropdown(select, {
        on_select: (value)=>{
            hooks.do(`gallery/select/${value}`)
            ui.trigger.textContent = 'Select Gallery';
        }
    })
}